/* tslint:disable */
/* eslint-disable */
/**
 * Farseer API
 * Farseer API
 *
 * The version of the OpenAPI document: 3
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
export function SearchSheetRowHierarchyRequestWithDataChildrenFromJSON(json) {
    return SearchSheetRowHierarchyRequestWithDataChildrenFromJSONTyped(json, false);
}
export function SearchSheetRowHierarchyRequestWithDataChildrenFromJSONTyped(json, ignoreDiscriminator) {
    if (json === undefined || json === null) {
        return json;
    }
    return {
        childId: json['childId'],
        withData: json['withData'],
    };
}
export function SearchSheetRowHierarchyRequestWithDataChildrenToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        childId: value.childId,
        withData: value.withData,
    };
}
